import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeft, ChevronRight } from 'lucide-react';
const images = ['https://cdn.magicpatterns.com/uploads/eiGuVoQ1EGFrtKEnzHsEaT/Screenshot_2026-06-18_at_10.59.27_PM.png', 'https://cdn.magicpatterns.com/uploads/9eYv2G1L9TRVrpCNcTR2Cm/Screenshot_2026-06-18_at_10.58.08_PM.png', 'https://cdn.magicpatterns.com/uploads/bNQ2AKjdDjuvZLFUmwt2CG/Screenshot_2026-06-18_at_10.58.30_PM.png', 'https://cdn.magicpatterns.com/uploads/sztw34oRChY8WzTFgNYrne/Screenshot_2026-06-18_at_10.59.02_PM.png'];
interface CarouselProps {
  onImageClick: () => void;
}
export function Carousel({
  onImageClick
}: CarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const handleDragEnd = (e: any, {
    offset
  }: any) => {
    const swipe = offset.x;
    if (swipe < -50) {
      next();
    } else if (swipe > 50) {
      prev();
    }
  };
  return <section className="bg-gray-50 py-16 md:py-24" data-id="element-17">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-19">
          El sistema por dentro
        </motion.h2>

        <div className="relative max-w-4xl mx-auto" data-id="element-20">
          <div className="relative aspect-[4/3] md:aspect-[16/11] bg-gray-100 rounded-xl overflow-hidden shadow-xl border border-gray-200" data-id="element-21">
            <AnimatePresence mode="wait" data-id="element-22">
              <motion.img key={currentIndex} src={images[currentIndex]} alt={`Sistema del 10 - Imagen ${currentIndex + 1}`} initial={{
              opacity: 0,
              x: 100
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -100
            }} transition={{
              duration: 0.3
            }} drag="x" dragConstraints={{
              left: 0,
              right: 0
            }} dragElastic={0.2} onDragEnd={handleDragEnd} className="w-full h-full object-contain cursor-pointer" onClick={onImageClick} data-id="element-23" />
            </AnimatePresence>

            <button onClick={prev} className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-lg transition-all z-10" aria-label="Anterior" data-id="element-24">
              <ChevronLeft className="w-6 h-6 text-gray-900" data-id="element-25" />
            </button>

            <button onClick={next} className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white/90 hover:bg-white flex items-center justify-center shadow-lg transition-all z-10" aria-label="Siguiente" data-id="element-26">
              <ChevronRight className="w-6 h-6 text-gray-900" data-id="element-27" />
            </button>
          </div>

          <div className="flex justify-center gap-2 mt-6" data-id="element-28">
            {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={`w-2 h-2 rounded-full transition-all ${index === currentIndex ? 'bg-emerald-600 w-8' : 'bg-gray-300'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-29" />)}
          </div>
        </div>
      </div>
    </section>;
}